document.addEventListener('DOMContentLoaded', function () {
	// Gift Card Collection carousel initialization
	new Swiper(".gc-card-chevron-updown-col-list .gc-container", {
		slidesPerView: 1.3,
		slidesPerGroupAuto: true,
		spaceBetween: 4,
		slidesOffsetBefore: 16,
		slidesOffsetAfter: 16,
		navigation: {
			nextEl: ".gc-containers-nav-buttons .gc-containers-swiper-next",
			prevEl: ".gc-containers-nav-buttons .gc-containers-swiper-prev",
		},
		breakpoints: {
			768: {
				slidesPerView: 4.25,
				slidesPerGroup: 1,
				slidesOffsetBefore: 40,
				slidesOffsetAfter: 40
			}
		},
	});
});